import ReactGA from 'react-ga4';

export const trackStatsFilter = (filterType, value) => {
  ReactGA.event({
    category: 'Filter Stats',
    action: filterType,
    label: value.toString()
  })
}